import { FC, memo } from 'react';
import type {
  IBetslipCalculationField,
  TBetslipCalculationPortalPlacement
} from 'newelements/_Betslip/hooks/generateFieldsMapping/types';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

export const BetslipCalculationResult: FC<
  IBetslipCalculationField | TBetslipCalculationPortalPlacement
> = memo(props => {
  return 'label' in props ? (
    <BetslipCalculationResultValue {...props} />
  ) : (
    <BetslipCalculationResultPortal {...props} />
  );
});

const BetslipCalculationResultValue: FC<IBetslipCalculationField> = memo(
  ({ label, value, attributes, loading }) => {
    return (
      <div
        {...(attributes || {})}
        className={`betslipFooterItem ${attributes?.className ?? ''}`}
      >
        <div className="betslipFooterItem--label">{label}</div>
        <div
          className="betslipFooterItem--value"
          {...(attributes?.['data-testid']
            ? { 'data-testid': `${attributes?.['data-testid']}-value` }
            : {})}
        >
          {loading ? (
            <Skeleton.Input style={{ width: 60, height: 15 }} active />
          ) : (
            value
          )}
        </div>
      </div>
    );
  }
);

const BetslipCalculationResultPortal: FC<TBetslipCalculationPortalPlacement> =
  memo(({ attributes, children }) => {
    return <div {...attributes}>{children || null}</div>;
  });
